import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import { categoryMap } from "@/mocks/categories";
import { formatViews } from "@/lib/content";

interface RankingListProps {
  articles: Article[];
  title: string;
  description?: string;
}

export default function RankingList({ articles, title, description }: RankingListProps) {
  return (
    <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-end justify-between border-b border-background-200 pb-3">
        <div>
          <p className="font-label text-[10px] uppercase tracking-[0.22em] text-primary-600">Ranking</p>
          <h3 className="mt-1 font-heading text-base font-bold text-foreground-950">{title}</h3>
        </div>
        <span className="flex items-center gap-1 text-[11px] text-foreground-400">
          <i className="ri-fire-line text-primary-500" />
          实时
        </span>
      </div>
      {description ? <p className="mt-3 text-xs leading-relaxed text-foreground-500">{description}</p> : null}
      <ol className="mt-1 divide-y divide-background-200">
        {articles.map((article, index) => (
          <li key={article.id}>
            <Link
              to={`/detail/article/${article.id}`}
              className="group flex items-start gap-3 py-3"
            >
              <span
                className={`mt-0.5 w-5 shrink-0 font-editorial text-sm font-bold ${
                  index < 3 ? "text-primary-500" : "text-background-400"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="min-w-0">
                <span className="line-clamp-2-custom block text-sm font-medium leading-relaxed text-foreground-900 transition-colors group-hover:text-primary-600">
                  {article.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                  <span>{categoryMap[article.category]?.name}</span>
                  <span className="text-background-400">·</span>
                  <span>{formatViews(article.views)} 阅读</span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
      <Link
        to={`/search?q=${encodeURIComponent("城市")}`}
        className="mt-auto flex items-center justify-center gap-1.5 rounded-md border border-background-300 py-2 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        查看更多热门内容
        <i className="ri-arrow-right-line" />
      </Link>
    </div>
  );
}